/**
 * A function that returns the URL part common to the endpoints.
 */
export const root = () => {
    let __root = "";
    if (process.env.NODE_ENV === "local") {
        __root = "http://localhost:8080";
    }
    if (process.env.NODE_ENV === "localDev") {
        __root = "";
    }
    if (process.env.NODE_ENV === "development") {
        __root = "https://api-forms.dev.m2msystems.cloud";
    }
    if (process.env.NODE_ENV === "production") {
        __root = "https://api-forms.m2msystems.cloud";
    }
    return __root;
};
/**
 * health check
 *
 */
export const healthCheck = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/health_check`;
    return __queries ? `${__path}?${__queries}` : __path;
};
healthCheck.method = "GET";
healthCheck.authSchema = { "type": "", "header": "" };
/**
 * DraftRevisionのフォーム情報を取得する
 *
 */
export const formGet = ({ id }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${id}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formGet.method = "GET";
formGet.authSchema = { "type": "", "header": "" };
/**
 * 特定のRevisionのフォーム情報を取得する
 *
 */
export const formGetByRevision = ({ id, revision }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${id}/${revision}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formGetByRevision.method = "GET";
formGetByRevision.authSchema = { "type": "", "header": "" };
/**
 * Formを新規作成する
 *
 */
export const formCreate = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formCreate.method = "POST";
formCreate.authSchema = { "type": "", "header": "" };
/**
 * ユーザーに紐づいたフォームを全件取得する
 *
 */
export const formFindAll = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formFindAll.method = "GET";
formFindAll.authSchema = { "type": "", "header": "" };
/**
 * Formを更新する
 *
 */
export const formUpdate = ({ id }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${id}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formUpdate.method = "PATCH";
formUpdate.authSchema = { "type": "", "header": "" };
/**
 * 他のユーザーが共有したフォームを全件取得する
 *
 */
export const sharedFormFindAll = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/shared-forms`;
    return __queries ? `${__path}?${__queries}` : __path;
};
sharedFormFindAll.method = "GET";
sharedFormFindAll.authSchema = { "type": "", "header": "" };
/**
 * Formのシート機能を有効化する
 *
 */
export const formActivateSheetFeature = ({ id }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${id}/sheets/activate`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formActivateSheetFeature.method = "PATCH";
formActivateSheetFeature.authSchema = { "type": "", "header": "" };
/**
 * フォームに紐づいたConnectedSheetを取得する
 *
 */
export const formGetConnectedSheet = ({ id }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${id}/connected-sheet`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formGetConnectedSheet.method = "GET";
formGetConnectedSheet.authSchema = { "type": "", "header": "" };
/**
 * Formの公開ステータスをPrivateに変更する
 *
 */
export const formPublishStatusChangeToPrivate = ({ id }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${id}/private`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formPublishStatusChangeToPrivate.method = "PATCH";
formPublishStatusChangeToPrivate.authSchema = { "type": "", "header": "" };
/**
 * FormのContentを更新する
 *
 */
export const formsCreateNewRevision = ({ id }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${id}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formsCreateNewRevision.method = "POST";
formsCreateNewRevision.authSchema = { "type": "", "header": "" };
/**
 * Formの質問の順番を更新する
 *
 */
export const formUpdateQuestionsOrder = ({ id }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${id}/questions/order`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formUpdateQuestionsOrder.method = "POST";
formUpdateQuestionsOrder.authSchema = { "type": "", "header": "" };
/**
 * Form内容を確定し公開する
 *
 */
export const formPublish = ({ id }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${id}/publish`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formPublish.method = "POST";
formPublish.authSchema = { "type": "", "header": "" };
/**
 * フォームのオーナーを指定されたユーザーに差し替える
 *
 */
export const formReplaceOwner = ({ id }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${id}/replace-owner`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formReplaceOwner.method = "POST";
formReplaceOwner.authSchema = { "type": "", "header": "" };
/**
 * 同じmatsuriドメインのユーザー間でフォームのオーナーを差し替える
 *
 */
export const formForceReplaceOwner = ({ id }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${id}/force-replace-owner`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formForceReplaceOwner.method = "POST";
formForceReplaceOwner.authSchema = { "type": "", "header": "" };
/**
 * 質問を作成する
 *
 */
export const formQuestionCreate = ({ formId }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/questions/append`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formQuestionCreate.method = "POST";
formQuestionCreate.authSchema = { "type": "", "header": "" };
/**
 * 質問を挿入する
 *
 */
export const formQuestionInsert = ({ formId }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/questions/insert`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formQuestionInsert.method = "POST";
formQuestionInsert.authSchema = { "type": "", "header": "" };
/**
 * 質問を削除する
 *
 */
export const formQuestionDelete = ({ formId }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/questions/delete`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formQuestionDelete.method = "POST";
formQuestionDelete.authSchema = { "type": "", "header": "" };
/**
 * 質問を更新する
 *
 */
export const formQuestionUpdate = ({ formId, questionId }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/questions/${questionId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formQuestionUpdate.method = "PATCH";
formQuestionUpdate.authSchema = { "type": "", "header": "" };
/**
 * フォームの質問をJSON形式でエクスポートする
 *
 */
export const formQuestionsExport = ({ formId }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/questions/export`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formQuestionsExport.method = "GET";
formQuestionsExport.authSchema = { "type": "", "header": "" };
/**
 * フォームにJSON形式の質問をインポートする
 *
 */
export const formQuestionsImport = ({ formId }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/questions/import`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formQuestionsImport.method = "POST";
formQuestionsImport.authSchema = { "type": "", "header": "" };
/**
 * @deprecated Use submissionSearch
 *
 */
export const submissionGet = ({ formId }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/submissions`;
    return __queries ? `${__path}?${__queries}` : __path;
};
submissionGet.method = "GET";
submissionGet.authSchema = { "type": "", "header": "" };
/**
 * 回答を検索
 *
 */
export const submissionSearch = ({ formId }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/submissions/search`;
    return __queries ? `${__path}?${__queries}` : __path;
};
submissionSearch.method = "POST";
submissionSearch.authSchema = { "type": "", "header": "" };
/**
 * 回答の再送
 *
 */
export const submissionResubmitToWebhook = ({ formId, submissionId }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/submissions/${submissionId}/resubmit`;
    return __queries ? `${__path}?${__queries}` : __path;
};
submissionResubmitToWebhook.method = "POST";
submissionResubmitToWebhook.authSchema = { "type": "", "header": "" };
/**
 * 回答を作成
 *
 */
export const submissionCreate = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/submissions`;
    return __queries ? `${__path}?${__queries}` : __path;
};
submissionCreate.method = "POST";
submissionCreate.authSchema = { "type": "", "header": "" };
/**
 * ゲストがフォームの情報を取得する
 *
 */
export const guestFormGet = ({ formId }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/guest/forms/${formId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
guestFormGet.method = "GET";
guestFormGet.authSchema = { "type": "", "header": "" };
/**
 * Googleのトークンでサインインする
 *
 */
export const signInWithGoogle = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/auth/signInWithGoogle`;
    return __queries ? `${__path}?${__queries}` : __path;
};
signInWithGoogle.method = "POST";
signInWithGoogle.authSchema = { "type": "", "header": "" };
/**
 * Googleのトークンでサインアップする
 *
 */
export const signUpWithGoogle = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/auth/signUpWithGoogle`;
    return __queries ? `${__path}?${__queries}` : __path;
};
signUpWithGoogle.method = "POST";
signUpWithGoogle.authSchema = { "type": "", "header": "" };
/**
 * フォームにWebhookを追加する
 *
 */
export const formWebhookAppend = ({ formId, appId }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/apps/${appId}/webhooks`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formWebhookAppend.method = "POST";
formWebhookAppend.authSchema = { "type": "", "header": "" };
/**
 * フォームに紐づいたWebhookを削除する
 *
 */
export const formWebhookDelete = ({ formId, appId, webhookId }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/apps/${appId}/webhooks/${webhookId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formWebhookDelete.method = "DELETE";
formWebhookDelete.authSchema = { "type": "", "header": "" };
/**
 * フォームに紐づいたWebhookを更新する
 *
 */
export const formWebhookUpdate = ({ formId, appId, webhookId }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/apps/${appId}/webhooks/${webhookId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formWebhookUpdate.method = "PATCH";
formWebhookUpdate.authSchema = { "type": "", "header": "" };
/**
 * フォームに紐づいたWebhookを全件取得する
 *
 */
export const formWebhookFindAll = ({ formId, appId }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/apps/${appId}/webhooks`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formWebhookFindAll.method = "GET";
formWebhookFindAll.authSchema = { "type": "", "header": "" };
/**
 * フォームAppに紐づいたSignatureKeyを生成する
 *
 */
export const formAppSignatureKeyGenerate = ({ formId, appId }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/apps/${appId}/signature_key`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formAppSignatureKeyGenerate.method = "POST";
formAppSignatureKeyGenerate.authSchema = { "type": "", "header": "" };
/**
 * フォームに紐づいたAppをFormIDから全件取得する
 *
 */
export const formAppFindAll = ({ formId }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/apps`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formAppFindAll.method = "GET";
formAppFindAll.authSchema = { "type": "", "header": "" };
/**
 * フォームに紐づいたAppをAppIDから取得する
 *
 */
export const formAppGet = ({ formId, appId }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/apps/${appId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formAppGet.method = "GET";
formAppGet.authSchema = { "type": "", "header": "" };
/**
 * フォームにAppを追加する
 *
 */
export const formAppAppend = ({ formId }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/apps`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formAppAppend.method = "POST";
formAppAppend.authSchema = { "type": "", "header": "" };
/**
 * フォームに紐づいたAppを削除する
 *
 */
export const formAppDelete = ({ formId, appId }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/apps/${appId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formAppDelete.method = "DELETE";
formAppDelete.authSchema = { "type": "", "header": "" };
/**
 * フォームに紐づいたAppを更新する
 *
 */
export const formAppUpdate = ({ formId, appId }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/apps/${appId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formAppUpdate.method = "PATCH";
formAppUpdate.authSchema = { "type": "", "header": "" };
/**
 * フォームに紐づいた権限を全件取得する。管理者以上のフォーム権限が必要。
 *
 */
export const formPermissionFindAllByFormId = ({ formId }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/permissions`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formPermissionFindAllByFormId.method = "GET";
formPermissionFindAllByFormId.authSchema = { "type": "", "header": "" };
/**
 * ユーザーに紐づいたフォームの権限を追加する。管理者以上のフォーム権限が必要。
 *
 */
export const formPermissionCreate = ({ formId }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/permissions`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formPermissionCreate.method = "POST";
formPermissionCreate.authSchema = { "type": "", "header": "" };
/**
 * ユーザーに紐づいたフォームの権限を更新する。管理者以上のフォーム権限が必要。
 *
 */
export const formPermissionUpdate = ({ formId, id }) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/forms/${formId}/permissions/${id}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
formPermissionUpdate.method = "PATCH";
formPermissionUpdate.authSchema = { "type": "", "header": "" };
export const matsuriForms_v1 = { healthCheck, formGet, formGetByRevision, formCreate, formFindAll, formUpdate, sharedFormFindAll, formActivateSheetFeature, formGetConnectedSheet, formPublishStatusChangeToPrivate, formsCreateNewRevision, formUpdateQuestionsOrder, formPublish, formReplaceOwner, formForceReplaceOwner, formQuestionCreate, formQuestionInsert, formQuestionDelete, formQuestionUpdate, formQuestionsExport, formQuestionsImport, submissionGet, submissionSearch, submissionResubmitToWebhook, submissionCreate, guestFormGet, signInWithGoogle, signUpWithGoogle, formWebhookAppend, formWebhookDelete, formWebhookUpdate, formWebhookFindAll, formAppSignatureKeyGenerate, formAppFindAll, formAppGet, formAppAppend, formAppDelete, formAppUpdate, formPermissionFindAllByFormId, formPermissionCreate, formPermissionUpdate };
